;
define("recently_viewed_row.tpl", function(){});

